import axios from 'axios';

axios.defaults.baseURL = window.baseURL + '/ajax';

axios.defaults.headers.common['Accept'] = 'application/json';
axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

axios.defaults.headers.post['Content-Type'] = 'application/json';

axios.defaults.withCredentials  = true; // если нужны куки
axios.defaults.timeout          = 10000; // таймаут запроса в миллисекундах
// 29.07: 20КБ резали страницу отзывов (та же грабля, что в админке -
// богатый JSON тихо превращался в cancelled). Ответ до 2МБ.
axios.defaults.maxContentLength = 2000000; // максимальный размер ответа
axios.defaults.maxBodyLength    = 20000; // максимальный размер тела запроса

export { axios };

export default (app) => {
    app.axios = axios;
    app.$http = axios;

    app.config.globalProperties.axios = axios;
    app.config.globalProperties.$http = axios;
    app.provide('axios', axios);
}